const config = {
    backend: 'https://backend.aptest.cancilico.site',
    localhost: 'https://aptest.cancilico.site/', //https://localhost:8000
    wsBackend: 'wss://backend.aptest.cancilico.site',
    publicRoot: '/',
    // latestSegmentationSetId: 3,
    labelSet: 4,
};

export default config;
